<template>
  <AppControl v-bind="$attrs" v-on="$listeners" :theme="theme">
    <AppInput
      :placeholder="placeholder"
      size="large"
      :theme="theme"
      :invalid="invalid"
      :value="value"
      @input="$emit('input', $event)"
    />
  </AppControl>
</template>

<script>
import AppControl from "./AppControl.vue";

export default {
  name: "AppControlText",
  inheritAttrs: false,
  components: {
    AppControl
  },
  props: {
    value: {},
    invalid: Boolean,
    placeholder: String,
    theme: {
      type: String,
      default: "main"
    }
  }
};
</script>
